<!--
 * @Author: Damon
 * @Date: 2021-01-19 10:48:20
 * @LastEditors: Damon
 * @LastEditTime: 2021-09-25 09:10:14
 * @Description: file content
-->
<template >
  <router-link v-if='hasPerms(perms)'
               :to='linkurl'>
    <el-link :type="type"
             :size="size">
      {{label}}
    </el-link>
  </router-link>
</template>

<script>
import { hasPermission } from '@/utils/auth';


export default {
  name: 'DLink',
  props: {
    label: { // 链接显示文本
      type: String,
      default: 'link',
    },
    size: { // 按钮尺寸
      type: String,
      default: 'mini',
    },
    type: { // 按钮类型
      type: String,
      default: null,
    },
    // loading: { // 按钮加载标识
    //   type: Boolean,
    //   default: false,
    // },
    // disabled: { // 按钮是否禁用
    //   type: Boolean,
    //   default: false,
    // },
    linkurl: {
      type: String,
      default: '',
    },
    perms: { // 按钮权限标识，外部使用者传入
      type: String,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    hasPerms(perms) {
      if (perms !== null && perms !== '') {
        return hasPermission(this.$route.path, perms) && !this.disabled;
      }
      return true;
      // 根据权限标识和外部指示状态进行权限判断
      //   return hasPermission(perms) && !this.disabled;
    },
  },
  mounted() {
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Link/DLink.vue